/**
 * SvgLoader.jsx
 * Created by Destin Frasier on 12/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const SvgLoading = ({ size }) => (
    <div className="rec-loader-wrap">
        <div className={`rec-loader-container rec-loader-size-${size}`}>
            <svg
                className="rec-loader"
                aria-label="Loading"
                alt="Loading"
                viewBox="25 25 50 50"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    className="rec-loader-path"
                    fill="none"
                    strokeWidth="4"
                    strokeMiterlimit="10"
                    cx="50"
                    cy="50"
                    r="20" />
            </svg>
        </div>
        <span className="rec-sr-only">Loading...</span>
    </div>
);

SvgLoading.propTypes = {
    size: PropTypes.string
};

SvgLoading.defaultProps = {
    size: 'large'
};

export default SvgLoading;
